import { format } from 'date-fns';
import { useMemo } from 'react';

import { EASTER_PROMO_DATE_START, MissionStatusGroups } from '../helpers';
import { PromoLabel } from '@/components/LabelsSection';
import { useCommonStore } from '@/store';

const eggDefault = '/easterMissions/label-default.webp';
const eggFinished = '/easterMissions/label-finished.webp';
const background = '/easterMissions/label-bg.webp';

export const useEasterLabel = (): PromoLabel => {
  const user = useCommonStore.use.user();
  const pendingUser = useCommonStore.use.pendingUser();

  const missionStatuses = useMemo(
    () => ({
      default: {
        character: eggDefault,
        disableAnimation: true,
        url: '/easter-quest',
      },
      qualified: {
        character: eggDefault,
        disableAnimation: false,
        url: '/easter-quest',
      },
      finished: {
        character: eggFinished,
        disableAnimation: true,
        url: '/promotions',
      },
    }),
    []
  );

  const { character, disableAnimation, url } = useMemo(() => {
    if (!user || pendingUser || !user.statuses) {
      return missionStatuses.default;
    }

    const missionQualified = user.statuses.find(({ id }) => {
      return id.startsWith(MissionStatusGroups.Qualified);
    });

    const dailyMissionPassed = user.statuses.find(({ id }) => {
      const promoFirstDay =
        Number(format(new Date(EASTER_PROMO_DATE_START), 'dd')) - 1;

      const dayNumber = new Date().getUTCDate() - promoFirstDay;

      const [userStatus] = id.split('_');

      return (
        userStatus === `${MissionStatusGroups.Daily}${dayNumber}` ||
        userStatus === `${MissionStatusGroups.Special}${dayNumber}`
      );
    });

    if (dailyMissionPassed && missionQualified) return missionStatuses.finished;

    if (missionQualified) return missionStatuses.qualified;

    return missionStatuses.default;
  }, [user, pendingUser, missionStatuses]);

  return {
    character,
    background,
    disableAnimation,
    url,
  };
};
